import { useMutation } from '@tanstack/react-query';
import { patchCreditMemoMode } from '../../Services/ProcessedTimesheetService';

const usePatchCreditMemoMode = (options = {}) =>
    useMutation(patchCreditMemoMode, {
        retry: false,
        ...options,
    });

export default usePatchCreditMemoMode;
